import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

export const SET_LOADING = 'SET_LOADING';
export const SET_ID = 'SET_ID';
export const SET_AVAILABLE_WORKFLOWS = 'SET_AVAILABLE_WORKFLOWS';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_LOADING]: (state, value) => Vue.set(state, 'loading', value),
	[SET_ID]: (state, id) => Vue.set(state, 'id', id),
	[SET_AVAILABLE_WORKFLOWS]: (state, workflowIds) => Vue.set(state, 'availableWorkflows', workflowIds),
};

export default mutations;
